export enum ViewType {
    SPLIT,
    MERGED
}
